import axios from 'axios';
import globalConstants from '@/utils/global-constants.js';
import router from '@/router';

// const backendBase = 'http://localhost:8888/api/';
const backendBase = globalConstants.BASE_URL;

export default {

  state: {
    // navbar
    assetInfo: { ticker: 'AAPL', name: 'Apple Inc.', exchange: 'NASDAQ Stock Exchange' },
    toTerminalAfterLogin: false,
    loginMessage: 'To view the full list of UniBit Opinion',

    // insight-news-page: featured news
    maxFeaturedNewsPage: 3,
    currentFeaturedNewsPage: 0,
    featuredNewsData: [],

    // insight-news-page: unibit opinion
    unibitOpinions: [],

    // insight-company-page
    companyDataMenu: [
      { name: "Tearsheet", link: "/insight/company/tearsheet" },
      { name: "Core Financials", link: "/insight/company/financials" },
      { name: "Insider Transaction", link: "/insight/company/insider" },
      { name: "Ownership", link: "/insight/company/ownership" },
      { name: "SEC Filing", link: "/insight/company/secfiling" }
    ],
    currentCompanyDataMenuItem: "Tearsheet", // ["Tearsheet", "Core Financials", "Insider Transaction", "Ownership", "SEC Filing"]

    // insight-company-page: price quote
    ranges: ["1D", "1W", "1M", "6M", "1Y", "5Y", "Max"],
    currentRange: "1D",
    priceQuoteData: {
      "1D": [], "1W": [], "1M": [], "6M": [], "1Y": [], "5Y": [], "Max": []
    },

    // insight-company-page: company realtime news
    companyRealtimeNews: [],
    currentCompanyNewsPage: 0,

    // insight-company-page: company profile
    companyProfile: {},

    companyFinancialsSelectors: {
      statement: 'IS',
      interval: 'A',
    },
    companyFinancials: {
      "IS": {
        "A": {
          dataSet: [],
          columns: []
        },
        "Q": {
          dataSet: [],
          columns: []
        },
        "TTM": {
          dataSet: [],
          columns: []
        }
      },
      "BS": {
        "A": {
          dataSet: [],
          columns: []
        },
        "Q": {
          dataSet: [],
          columns: []
        },
        "TTM": {
          dataSet: [],
          columns: []
        }
      },
      "CF": {
        "A": {
          dataSet: [],
          columns: []
        },
        "Q": {
          dataSet: [],
          columns: []
        },
        "TTM": {
          dataSet: [],
          columns: []
        }
      },
    },
    companyOwnership: {
      majority_holder: {
        dataSet: [],
        columns: []
      },
      top_institutional_holder: {
        dataSet: [],
        columns: []
      },
      top_mutual_fund_holder: {
        dataSet: [],
        columns: []
      },
    },
    companySEC: {
      dataSet: [],
      columns: []
    },
    companyInsider: {
      dataSet: [],
      columns: []
    }
  },

  // Mutations Must Be Synchronous
  mutations: {
    setAssetInfo(state, assetInfo) {
      if (state.assetInfo.ticker != assetInfo.ticker) {
        state.assetInfo = assetInfo;
        state.priceQuoteData = {
          "1D": [], "1W": [], "1M": [], "6M": [], "1Y": [], "5Y": [], "Max": []
        };

        state.companyRealtimeNews = [];

        state.companyFinancials = {
          "IS": {
            "A": [],
            "Q": [],
            "TTM": []
          },
          "BS": {
            "A": [],
            "Q": [],
            "TTM": []
          },
          "CF": {
            "A": [],
            "Q": [],
            "TTM": []
          }
          // state.currentRange = "1D";
        };
        state.companyOwnership = {
          majority_holder: {
            dataSet: [],
            columns: []
          },
          top_institutional_holder: {
            dataSet: [],
            columns: []
          },
          top_mutual_fund_holder: {
            dataSet: [],
            columns: []
          },
        };
        state.companySEC = {
          dataSet: [],
          columns: []
        };
        state.companyInsider = {
          dataSet: [],
          columns: []
        };

        router.push({ name: router.currentRoute.name, params: { ticker: assetInfo.ticker } })
      }
    },

    /***********************************************************
    * 0. Insight Company Page: set company menu item...
    ***********************************************************/

    setCurrentCompanyDataMenuItem(state, menuItem) {
      if (state.currentCompanyDataMenuItem != menuItem)
        state.currentCompanyDataMenuItem = menuItem;
    },

    // setLogInToTerminal(state, toTerminal) {
    //   state.toTerminalAfterLogin = toTerminal;
    // },

    // setLogInMessage(state, message) {
    //   state.loginMessage = message;
    // },

    /***********************************************************
     * 2. Insight Company Page: get asset key indicators, price quote, news...
     ***********************************************************/
    setCurrentPriceQuoteChartRange(state, range) {
      if (state.currentRange != range)
        state.currentRange = range;
    },

    setPriceQuoteData(state, data) {
      if (state.priceQuoteData[state.currentRange].length == 0) {
        state.priceQuoteData[state.currentRange] = data;
      }
    },

    setCompanyRealtimeNews(state, data) {
      state.companyRealtimeNews = data;
    },

    setCompanyProfile(state, data) {
      state.companyProfile = data;
    },

    setCompanyFinancials(state, data) {
      state.companyFinancials[state.companyFinancialsSelectors.statement][state.companyFinancialsSelectors.interval] = data;
    },

    setCompanyFinancialsSelectors(state, data) {
      state.companyFinancialsSelectors[data.type] = data.option;
    },

    setCompanyOwnership(state, data) {
      state.companyOwnership = data;
    },

    setCompanySEC(state, data) {
      state.companySEC = data;
    },

    setCompanyInsider(state, data) {
      state.companyInsider = data;
    },

    /***********************************************************
    * 3. Insight News Page...
    ***********************************************************/

    setFeaturedNewsData(state, data) {
      state.featuredNewsData = data;
    },

    setCurrentFeaturedNewsPage(state, data) {
      state.currentFeaturedNewsPage = data;
    },
  },
  actions: {
    /***********************************************************
     * 1. Insight News Page: get global headline & featured news
     ***********************************************************/

    getAssetHeadlines() {
      return axios.get(`${backendBase}insight/news/headlines`);
    },

    getFeaturedNews({ commit, state }, apikey) {
      let option = null;
      if (apikey) option = { headers: { Authorization: apikey } };
      return axios.get(`${backendBase}insight/news/fd?page=${state.currentFeaturedNewsPage}`, option);
    },

    /***********************************************************
     * get unibit opinions
     ***********************************************************/

    getUnibitOpinions({ commit, state }, limit) {
      return axios.get("https://cms.unibit.ai/research?_limit=" + limit + "&_sort=id:DESC");
    },

    getUnibitOpinionsById({ commit, state }, id) {
      return axios.get('https://cms.unibit.ai/research?id=' + id);
    },

    getUnibitOpinionsImage({ commit, state }, url) {
      return axios.get('https://cms.unibit.ai/' + url);
    },

    /***********************************************************
     * 2. Insight Company Page: get asset key indicators, price quote, news...
     ***********************************************************/

    getAssetIndicatorData({ commit, state }) {
      return axios.get(`${backendBase}insight/asset/${state.assetInfo.ticker}`);
    },

    getAssetPriceQuoteData({ commit, state }) {
      return axios.get(`${backendBase}insight/asset/pc/${state.assetInfo.ticker}`, { params: { "range": state.currentRange } });
    },

    getAssetRealtimeNews({ commit, state }, apikey) {
      let option = null;
      if (apikey) option = { headers: { Authorization: apikey } };
      return axios.get(`${backendBase}insight/asset/ns/${state.assetInfo.ticker}?page=${state.currentCompanyNewsPage}`, option);
    },

    getAssetProfile({ commit, state }) {
      return axios.get(`${backendBase}insight/asset/pf/${state.assetInfo.ticker}`);
    },

    getPeerCompanyInfo({ commit, state }) {
      return axios.get(`${backendBase}insight/asset/pr/${state.assetInfo.ticker}`);
    },

    getAssetFinancials({ commit, state }, apikey) {
      let option = null;
      if (apikey) option = { headers: { Authorization: apikey } };
      return axios.get(`${backendBase}insight/asset/cf?ticker=${state.assetInfo.ticker}&interval=${state.companyFinancialsSelectors.interval}&statement=${state.companyFinancialsSelectors.statement}`, option);
    },

    getAssetOwnership({ commit, state }) {
      return axios.get(`${backendBase}insight/asset/os?ticker=${state.assetInfo.ticker}`)
    },

    getAssetSEC({ commit, state }, apikey) {
      let option = null;
      if (apikey) option = { headers: { Authorization: apikey } };
      return axios.get(`${backendBase}insight/asset/sf?ticker=${state.assetInfo.ticker}`, option)
    },

    getAssetInsider({ commit, state }, apikey) {
      let option = null;
      if (apikey) option = { headers: { Authorization: apikey } };
      return axios.get(`${backendBase}insight/asset/it?ticker=${state.assetInfo.ticker}`, option)
    }
  },
  // getters: {}
  getters: {
    companyFinancialsDataSet(state) {
      return state.companyFinancials[state.companyFinancialsSelectors.statement][
        state.companyFinancialsSelectors.interval
      ].dataSet;
    },
    companyFinancialsColumns(state) {
      return state.companyFinancials[state.companyFinancialsSelectors.statement][
        state.companyFinancialsSelectors.interval
      ].columns;
    }
  }

}


// WEBPACK FOOTER //
// ./src/store/page-service.js